import type { FacebookPage, PublishPostParams } from './types';

import { apiClient } from '~shared/api/createApiClient';

export const storeKey = (
  pharmacyId: string,
  userShortLivedAccessToken: string
): Promise<FacebookPage[]> =>
  apiClient.post<FacebookPage[]>(
    '/share/fb/store-key',
    { userShortLivedAccessToken },
    { pharmacyId }
  );

export const getPages = (pharmacyId: string): Promise<FacebookPage[]> =>
  apiClient.get<FacebookPage[]>('/share/fb/pages', { pharmacyId });

export const deleteStoreKey = (pharmacyId: string): Promise<void> =>
  apiClient.delete<void>('/share/fb/store-key', { pharmacyId });

export const publishPost = (
  pharmacyId: string,
  pageId: string,
  params: PublishPostParams
): Promise<void> =>
  apiClient.post<void>(`/share/fb/pages/${pageId}/publish`, params, {
    pharmacyId,
  });
